import React, { Children, cloneElement } from "react";
import LegendLayers from "./LegendLayers";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import { Geosearch } from "esri-leaflet-geocoder";

import { MapControl, withLeaflet, ControlledLayer } from "react-leaflet";

//children layers to the parent class "CLAYERCONTROL" below
class BaseLayer extends ControlledLayer {
    constructor(props) {
        super(props);
        this.contextValue = {
            ...props.leaflet,
            layerContainer: {
                addLayer: this.addLayer.bind(this),
                removeLayer: this.removeLayer.bind(this)
            }
        };
    }

    addLayer = layer => {
        this.layer = layer; // Keep layer reference to handle dynamic changes of props
        const { addBaseLayer, checked, name } = this.props;
        addBaseLayer(layer, name, checked);
    };
}

//children layers to the parent class "CLAYERCONTROL" below
class Overlay extends ControlledLayer {
    constructor(props) {
        super(props);
        this.contextValue = {
            ...props.leaflet,
            layerContainer: {
                addLayer: this.addLayer.bind(this),
                removeLayer: this.removeLayer.bind(this)
            }
        };
    }

    addLayer = layer => {
        this.layer = layer; // Keep layer reference to handle dynamic changes of props
        const { addOverlay, checked, name } = this.props;
        addOverlay(layer, name, checked);
    };
}

//children layers to the parent class "CLAYERCONTROL" below
class AdvancedSearchOverlay extends ControlledLayer {
    constructor(props) {
        super(props);
        this.contextValue = {
            ...props.leaflet,
            layerContainer: {
                addLayer: this.addLayer.bind(this),
                removeLayer: this.removeLayer.bind(this)
            }
        };
    }

    addLayer = layer => {
        this.layer = layer; // Keep layer reference to handle dynamic changes of props
        const { addAdvancedSearchOverlay, checked, name } = this.props;
        addAdvancedSearchOverlay(layer, name, checked);
    };
}

//adds the various layers/controls to the map. This is the 'base, overlay, and advancedSearchoverlay' containers which are the children
class CLayersControl extends MapControl {
    constructor(props) {
        super(props);
        this.controlProps = {
            addBaseLayer: this.addBaseLayer.bind(this),
            addOverlay: this.addOverlay.bind(this),
            addAdvancedSearchOverlay: this.addAdvancedSearchOverlay.bind(this),
            leaflet: props.leaflet,
            removeLayer: this.removeLayer.bind(this),
            removeLayerControl: this.removeLayerControl.bind(this)
        };
    }

    createLeafletElement(props) {
        const { children: _children, controlPosition, viewOnly, ...options } = props;

        const search = new Geosearch({ expanded: true, useMapBounds: false, collapseAfterResult: false, provider: new OpenStreetMapProvider() });

        if (!viewOnly) {
            this.props.leaflet.map.addControl(search);
        }

        options.sections = [{ title: "TRS Search", html: "Township:<br/><select id='trs_township'><option>026</option><option>027</option><option>028</option><option>029</option><option>030</option><option>031</option><option>032</option><option>033</option><option>034</option><option>035</option><option>036</option><option>037</option><option>038</option><option>039</option><option>040</option><option>041</option><option>042</option><option>043</option><option>044</option><option>045</option><option>046</option><option>047</option><option>048</option><option>049</option><option>050</option><option>051</option><option>052</option><option>053</option><option>054</option><option>055</option><option>056</option><option>057</option><option>058</option><option>059</option><option>060</option><option>061</option><option>062</option><option>063</option><option>064</option><option>065</option><option>066</option><option>067</option><option>068</option><option>069</option><option>070</option><option>071</option><option>072</option><option>073</option><option>074</option><option>075</option><option>076</option><option>077</option><option>078</option><option>079</option><option>080</option><option>081</option><option>082</option><option>083</option><option>084</option><option>085</option><option>086</option><option>087</option><option>088</option><option>089</option><option>090</option><option>091</option><option>092</option><option>093</option><option>094</option><option>095</option><option>096</option><option>097</option><option>098</option><option>099</option><option>100</option><option>101</option><option>102</option><option>103</option><option>104</option><option>105</option><option>106</option><option>107</option><option>108</option><option>109</option><option>110</option><option>111</option><option>112</option><option>113</option><option>114</option><option>115</option><option>116</option><option>117</option><option>118</option><option>119</option><option>120</option><option>121</option><option>122</option><option>123</option><option>124</option><option>125</option><option>126</option><option>127</option><option>128</option><option>129</option><option>130</option><option>131</option><option>132</option><option>133</option><option>134</option><option>135</option><option>136</option><option>137</option><option>138</option><option>139</option><option>140</option><option>141</option><option>142</option><option>143</option><option>144</option><option>145</option><option>146</option><option>147</option><option>148</option><option>149</option><option>150</option><option>151</option><option>152</option><option>153</option><option>154</option><option>155</option><option>156</option><option>157</option><option>158</option><option>159</option><option>160</option><option>161</option><option>162</option><option>163</option><option>164</option><option>165</option><option>166</option><option>167</option><option>168</option></select><br/>Range:<br/><select id='trs_range'><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option><option>32</option><option>33</option><option>34</option><option>35</option><option>36</option><option>37</option><option>38</option><option>39</option><option>40</option><option>41</option><option>42</option><option>43</option><option>44</option><option>45</option><option>46</option><option>47</option><option>48</option><option>49</option><option>50</option><option>51</option></select><br/>Section:<br/><select id='trs_section'><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option>    <option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option><option>32</option><option>33</option><option>34</option><option>35</option><option>36</option></select><br/><br/><button id='trs_button' type='button' onClick='TRSZoom()'>Search</button><br/><span id='trs_loading' style='display:none;'>Loading...</span><span id='trs_error' style='display:none;'>No results found</span>"    }];
        return new LegendLayers(undefined, undefined, options);
    }

    componentWillUnmount() {
        setTimeout(() => {
            super.componentWillUnmount();
        }, 0);
    }

    addBaseLayer(layer, name, checked = false) {
        if (checked && this.props.leaflet.map != null) {
            this.props.leaflet.map.addLayer(layer);
        }
        this.leafletElement.addBaseLayer(layer, name);
    }

    addOverlay(layer, name, checked = false) {
        if (checked && this.props.leaflet.map != null) {
            this.props.leaflet.map.addLayer(layer);
        }
        // Should no longer need this now that wms is transparent?
        /*layer.on("load", function() {
            layer.bringToBack();
        });*/
        this.leafletElement.addOverlay(layer, name);
    }

    addAdvancedSearchOverlay(layer, name, checked = false) {
        if (checked && this.props.leaflet.map != null) {
            this.props.leaflet.map.addLayer(layer);
        }
        this.leafletElement.addAdvancedSearchOverlay(layer, name);
    }

    removeLayer(layer) {
        if (this.props.leaflet.map != null) {
            this.props.leaflet.map.removeLayer(layer);
        }
    }

    removeLayerControl(layer) {
        if (layer) this.leafletElement.removeLayer(layer);
    }

    render() {
        const children = Children.map(this.props.children, child => {
            return child ? cloneElement(child, this.controlProps) : null;
        });

        return <>{children}</>;
    }
}
const CollapsibleLayersControl = withLeaflet(CLayersControl);

CollapsibleLayersControl.BaseLayer = BaseLayer;
CollapsibleLayersControl.Overlay = Overlay;
CollapsibleLayersControl.AdvancedSearchOverlay = AdvancedSearchOverlay;

export default CollapsibleLayersControl;
